module.exports = __webpack_public_path__ + "static/media/CircularStd-Medium.e4ba63a6.ttf";